import { FetchStreetTypeCommand } from '@/Application/Localization/FetchStreetTypeCommand'
import { StreetTypeDto } from '@/Application/Localization/StreetTypeDto'
import { StreetTypeRepository } from '@/Domain/Localization/StreetType'
import { LanguageCode } from '@/Domain/Localization'

export class FetchStreetTypeCommandHandler {
  private _repository: StreetTypeRepository

  constructor (repository: StreetTypeRepository) {
    this._repository = repository
  }

  async handle (command: FetchStreetTypeCommand): Promise<StreetTypeDto[]> {
    const items = await this._repository.byLanguageCode(
      command.languageCode() as LanguageCode
    )
    const response = items.map(current => StreetTypeDto.fromStreetType(current))
    return response
  }
}
